import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, toDisplayString as _toDisplayString, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "py-2" }
const _hoisted_2 = { class: "flex items-start" }
const _hoisted_3 = { class: "flex-none" }
const _hoisted_4 = { class: "w-full" }
const _hoisted_5 = { class: "flex items-start" }
const _hoisted_6 = { class: "w-full" }
const _hoisted_7 = { class: "flex items-center px-2" }
const _hoisted_8 = ["placeholder", "rows"]
const _hoisted_9 = { class: "form-error-text" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "flex" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "whitespace-nowrap" }, " 確認 ")
], -1)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = {
  style: {"white-space":"pre-wrap","word-wrap":"break-word"},
  class: "px-2 pt-2 pb-1"
}
const _hoisted_13 = { class: "flex items-center justify-end" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "text-xs font-medium text-gray-500 pt-2 px-2 sm:px-4" }, [
  /*#__PURE__*/_createTextVNode(" こちらのコーナーでは、講義内容への質問・感想を受け付けております。 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("※返信には、お日にちをいただく場合がございます。 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("※ご質問をいただく場合は、講義内容に沿った内容でお願いします。 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("※全てのご質問にお答えすることを保証したものではございません。 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("※質問は「〇〇について教えてください」ではなく "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", { class: "px-1" }),
  /*#__PURE__*/_createTextVNode("「〇〇について自分の考えはこうですが、これでよろしいでしょうか？」といった "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", { class: "px-1" }),
  /*#__PURE__*/_createTextVNode("具体的な内容でお願いいたします。 ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_avatar = _resolveComponent("base-avatar")!
  const _component_base_form_submit = _resolveComponent("base-form-submit")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_base_avatar)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("form", {
          onSubmit: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)))
        }, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _withDirectives(_createElementVNode("textarea", {
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.message) = $event)),
                  id: "message",
                  name: "message",
                  placeholder: _ctx.t('video_details.question.form.message'),
                  class: _normalizeClass(`form-input mb-0 ${_ctx.errors['message'] ? 'border-red-500' : ''}`),
                  rows: _ctx.message ? _ctx.message.split('\n').length: 1
                }, null, 10, _hoisted_8), [
                  [_vModelText, _ctx.message]
                ])
              ]),
              _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.errors['message']), 1)
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("button", {
                type: "button",
                class: "py-1.5 px-4 bg-blue-500 hover:bg-blue-400 text-white rounded disabled:opacity-75",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onDialog()))
              }, _hoisted_11)
            ])
          ]),
          _createVNode(_component_el_dialog, {
            modelValue: _ctx.dialogVisible,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.dialogVisible) = $event)),
            title: "確認画面",
            width: "90%"
          }, {
            footer: _withCtx(() => [
              _createElementVNode("span", _hoisted_13, [
                _createElementVNode("button", {
                  type: "button",
                  class: "bg-gray-200 hover:bg-gray-300 text-gray-800 py-1.5 px-4 rounded disabled:opacity-75 mr-2",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.dialogVisible = false))
                }, "キャンセル"),
                _createVNode(_component_base_form_submit, { disabled: _ctx.btnDisabled }, null, 8, ["disabled"])
              ])
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.message), 1)
              ])
            ]),
            _: 1
          }, 8, ["modelValue"])
        ], 32)
      ])
    ]),
    _hoisted_14
  ]))
}